module.exports = __webpack_public_path__ + "static/media/logo3.8e1ec587.png";